export default {
  // Header
  nav_projetos: 'Projetos',
  nav_como_funciona: 'Como funciona',
  nav_faq: 'FAQ',
  cta_orcamento: 'Solicitar orçamento',

  // Hero
  hero_eyebrow: 'Sites e sistemas que trabalham pelo seu negócio',
  hero_title_1: 'Transformamos ideias em experiências digitais que',
  hero_title_highlight: 'geram resultados',
  hero_subtitle: 'Criamos landing pages focadas em conversão e sistemas personalizados para empresas que querem vender mais, automatizar processos e crescer com tecnologia.',
  hero_cta: 'Solicitar meu orçamento',
  hero_microcopy: 'Conte sua ideia. Nós ajudamos a transformar em solução.',
  hero_badge_leads: '+ Leads',
  hero_badge_automacao: 'Automação',
  hero_badge_performance: 'Performance',
  hero_badge_conversao: 'Conversão',

  // Trust bar
  trust_estrategia: 'Estratégia',
  trust_design: 'Design',
  trust_desenvolvimento: 'Desenvolvimento',
  trust_performance: 'Performance',

  // Problem
  problem_title: 'Seu negócio não precisa de apenas mais um site.',
  problem_text: 'Precisa de uma ferramenta pensada para gerar oportunidades, facilitar processos e ajudar sua empresa a crescer.',
  problem_1_title: 'Sites que não convertem',
  problem_1_text: 'Design bonito sem estratégia não gera resultado.',
  problem_2_title: 'Processos manuais',
  problem_2_text: 'Planilhas, mensagens e tarefas repetitivas consomem tempo.',
  problem_3_title: 'Soluções genéricas',
  problem_3_text: 'Seu negócio tem processos próprios. A tecnologia precisa acompanhar.',
  problem_conclusion: 'É exatamente aí que a Camaleal entra.',

  // Portfolio
  portfolio_title: 'Projetos que unem design, tecnologia e estratégia.',
  portfolio_subtitle: 'Cada projeto é uma solução única, construída para um objetivo específico.',

  // Process
  process_title: 'Da ideia ao projeto funcionando.',
  process_1_title: 'Entendemos seu negócio',
  process_1_text: 'Objetivos, público, processos e necessidades.',
  process_2_title: 'Planejamos a solução',
  process_2_text: 'Estrutura, experiência, estratégia e funcionalidades.',
  process_3_title: 'Criamos e desenvolvemos',
  process_3_text: 'Design profissional e desenvolvimento completo.',
  process_4_title: 'Publicamos e evoluímos',
  process_4_text: 'Projeto no ar, acompanhamento e possibilidade de melhorias.',

  // Transform
  transform_title: 'Você explica o problema.',
  transform_title_2: 'Nós transformamos em solução digital.',
  transform_antes: 'Antes',
  transform_depois: 'Depois',
  transform_a1: 'Planilhas',
  transform_a2: 'Processos manuais',
  transform_a3: 'Sites antigos',
  transform_a4: 'Informações espalhadas',
  transform_a5: 'Baixa conversão',
  transform_d1: 'Sistema centralizado',
  transform_d2: 'Automação',
  transform_d3: 'Experiência profissional',
  transform_d4: 'Dados organizados',
  transform_d5: 'Mais oportunidades',

  // Social proof
  social_title: 'Quem trabalha com a Camaleal',
  social_video_subtitle: 'Veja de perto o que criamos e como ajudamos nossos clientes a crescer.',

  // Why invest
  invest_title: 'Um projeto digital deve se pagar em resultado.',
  invest_1_title: 'Mais oportunidades',
  invest_1_text: 'Uma experiência melhor aumenta as chances do visitante entrar em contato.',
  invest_2_title: 'Mais eficiência',
  invest_2_text: 'Automatize tarefas que hoje dependem de processos manuais.',
  invest_3_title: 'Mais profissionalismo',
  invest_3_text: 'Fortaleça a percepção da sua marca desde o primeiro contato.',

  // CTA
  cta_title: 'Tem uma ideia? Vamos transformar em um projeto de verdade.',
  cta_text: 'Conte o que sua empresa precisa e vamos avaliar a melhor solução para o seu negócio.',
  cta_btn: 'Solicitar orçamento',
  cta_note: 'Sem compromisso.',

  // FAQ
  faq_title: 'Perguntas frequentes',
  faq_1_q: 'Quanto custa criar uma landing page?',
  faq_1_a: 'O valor depende do objetivo, da complexidade e das integrações de cada projeto. Cada orçamento é personalizado para o que seu negócio realmente precisa.',
  faq_2_q: 'O desenvolvimento é personalizado?',
  faq_2_a: 'Sim. Cada projeto é planejado do zero para atender ao objetivo específico do seu negócio, sem soluções genéricas.',
  faq_3_q: 'Vocês desenvolvem sistemas do zero?',
  faq_3_a: 'Sim. Desenvolvemos sistemas web sob medida, com painéis, dashboards e automações construídos para a realidade da sua empresa.',
  faq_4_q: 'Quanto tempo leva para desenvolver um projeto?',
  faq_4_a: 'O prazo varia conforme o escopo. Landing pages costumam ser mais rápidas, enquanto sistemas exigem mais tempo. Definimos prazos claros no início do projeto.',
  faq_5_q: 'O site funciona no celular?',
  faq_5_a: 'Sim. Todo projeto é desenvolvido mobile-first, garantindo uma experiência fluida em qualquer dispositivo.',
  faq_6_q: 'Vocês fazem integrações com outros sistemas?',
  faq_6_a: 'Sim. Integramos com APIs, WhatsApp, plataformas de pagamento, ferramentas de marketing e outros sistemas conforme a necessidade.',
  faq_7_q: 'Posso solicitar alterações depois do lançamento?',
  faq_7_a: 'Sim. Oferecemos acompanhamento e possibilidade de evolução contínua do projeto após o lançamento.',

  // Form
  form_title: 'Vamos falar sobre o seu projeto',
  form_subtitle: 'Só o seu nome e o que você precisa. A conversa continua no WhatsApp.',
  form_name: 'Nome',
  form_need: 'O que você precisa?',
  form_need_1: 'Landing Page',
  form_need_2: 'Sistema',
  form_need_3: 'Ainda não sei',
  form_submit: 'Continuar no WhatsApp',
  form_success: 'Tudo certo! Estamos te levando para o WhatsApp para finalizar o contato.',

  // Footer
  footer_slogan: 'Design, tecnologia e estratégia para transformar negócios.',
  footer_contato: 'Contato',
  footer_instagram: 'Instagram',
  footer_whatsapp: 'WhatsApp',
  footer_rights: '© 2026 Camaleal. Todos os direitos reservados.',
};